<template>
  <footer class="lowin-footer">
    <div>
      <el-link :underline="false">IM空间</el-link>
      <el-divider direction="vertical"></el-divider>
      <el-link href="https://beian.miit.gov.cn" target="_blank">桂ICP备2024019639号</el-link>
    </div>
  </footer>
</template>

<script>
    export default {
        name: "IcpFooter"
    }
</script>

<style scoped>
  footer {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    width: 100%;
    position: fixed;
    bottom: 3%;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/IcpFooter.vue